<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button type="primary" @click="CreateRole()" size="mini">新建权限组</el-button>
      </div>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="权限组名称" width="150">
      </el-table-column>
      <el-table-column label="权限内容">
        <template slot-scope="scope">
          <span v-html="getResources(scope.row.resources)"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="复制并新建权限" placement="bottom">
            <i class="iconfont icon-cope meeting-btn-icon mbi-edit" @click="CopeRole(scope.row)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="修改该权限组" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="UpdateRole(scope.row)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除该权限组" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="DeleteRole(scope.row)"></i>
          </el-tooltip>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <section class="pop-room role-pop" v-if="createRoleStatus">
      <a href="javascript:;" @click="createRoleStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <h3 class="title">{{title}}</h3>
        <el-row>
          <el-col :span="20">
            <el-input size="small" placeholder="请输入权限组名称" v-model="form.name"></el-input>
          </el-col>
        </el-row>
        <el-radio-group v-model="form.type">
          <el-radio :label="0">超级管理员</el-radio>
          <el-radio :label="1">其他权限</el-radio>
        </el-radio-group>
        <el-tree :data="resourceList" show-checkbox default-expand-all node-key="id" ref="tree" highlight-current
          :props="defaultProps">
        </el-tree>
      </div>
      <div class="btn-room">
        <el-button @click="submitRole()" type="primary">确认提交</el-button>
      </div>
    </section>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 权限资源
        title: '新建权限组',
        createRoleStatus: false,
        form: {
          name: '',
          resourceIds: "",
          type: 1
        },
        resourceList: [],
        defaultProps: {
          children: 'childs',
          label: 'name'
        }
      }
    },
    mounted() {
      this.getLists()
      this.getResource()
    },
    components: {},
    methods: {
      // 拷贝权限
      CopeRole(row) {
        this.createRoleStatus = true
        let keys = row.resources ? row.resources.map(item => item.id) : []
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(keys)
        })
      },
      // 更改权限
      UpdateRole(row) {
        this.createRoleStatus = true
        let keys = row.resources ? row.resources.map(item => item.id) : []
        this.form.name = row.name
        this.form.type = row.type / 1
        this.form.roleId = row.id
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(keys)
        })

      },
      // 删除权限
      DeleteRole(row) {
        this.$confirm('此操作将永久删除该权限组，删除后将会对该权限组的成员产生影响, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/sys/role/del', {
            roleId: row.id
          }, (res) => {
            this.$message.success('权限组删除成功')
            this.getLists()
          })
        }).catch(() => {});
      },
      CreateRole() {
        this.createRoleStatus = true
        this.form = {
          name: '',
          resourceIds: "",
          type: 1,
          roleId: '',
        }
      },
      getResources(resources) {
        if (!resources) {
          return
        }
        let _resources = []
        for (var i = 0; i < resources.length; i++) {
          // 去除第0项权限显示
          if (!resources[i].sourceKey.match("_0")) {
            _resources.push(resources[i])
          }
        }

        return _resources.map(item => item.name).join("，")
      },
      submitRole() {
        if (!this.form.name) {
          this.$message.error('权限组名称不能为空')
        }
        this.form.resourceIds = this.$refs.tree.getCheckedKeys().join(",")

        let url = '/sys/role/add'
        if (this.form.roleId) {
          this.title = "更改权限组"
          url = '/sys/role/edit'
        }
        ajax.post(url, this.form, (res) => {
          this.form = {
            name: '',
            resourceIds: "",
            type: 1,
            roleId: '',
          }
          this.$message.success(this.title + '成功')
          this.getLists()
          this.createRoleStatus = false
        })
      },
      getResource() {
        ajax.get('/sys/resource/tree', '', (res) => {
          this.resourceList = res.vo.array
        })
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      getLists() {
        ajax.get('/sys/role/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {

    }
  };
</script>


// WEBPACK FOOTER //
// src/page/set/rolelist.vue